import script from "./StudentInSeat.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentInSeat.vue?vue&type=script&setup=true&lang=ts"

import "./StudentInSeat.vue?vue&type=style&index=0&id=77be1c7e&lang=scss"

const __exports__ = script;

export default __exports__